import React from 'react'
import TimerWidget from './TimerWidget'

const TimerInput = ({ timeString, onTimerInputCB }) => {
    const [hours = '00', minutes = '00', seconds = '00'] = (timeString || '00_00_00').split('_');

    return (
        <div className='popup_body' style={{ gap: '0.3rem' }}>
            <TimerWidget
                maxCount={23}
                handleTimerInputCB={onTimerInputCB}
                type='HOUR'
                min='00'
                max='23'
                maxLength='2'
                defaultValue={Number(hours)}
            />
            :
            <TimerWidget
                maxCount={59}
                handleTimerInputCB={onTimerInputCB}
                type='MIN'
                min='00'
                max='59'
                maxLength='2'
                defaultValue={Number(minutes)}
            />
            :
            <TimerWidget
                maxCount={59}
                handleTimerInputCB={onTimerInputCB}
                type='SEC'
                min='00'
                max='59'
                maxLength='2'
                defaultValue={Number(seconds)}
            />
        </div>
    )
}

export default TimerInput
